<template>
    <v-dialog v-model="exibirModalAssinatura" width="1000" max-width="80vw">
        <v-card style="max-width: 100%">
             <v-toolbar color="blue" class="mb-8">
                <v-flex  style="display: flex" class="pa-2">
                    <span style="width:95%;color:white;font-weight:bold;" >
                        Assinatura
                    </span>
                    <span style="width:5%">
                        <!-- <BotaoTutorial categoria="14" legenda="teste" urlVideo=""/> -->
                    </span>
                    <span style="width:5%;">
                        <v-btn x-small color="red" @click="fechar()" title="Fechar">
                            <v-icon x-small style="color:white;">mdi-close</v-icon>
                        </v-btn>
                    </span>
                </v-flex>
            </v-toolbar>

            <v-card-text>
                <v-card style="padding:10px;margin-bottom:10px;">
                    <div style="width:100%;">
                        <img v-if="imgsrc" v-bind:src="'data:image/jpeg;base64,'+imgsrc" />
                    </div>
                    <div style="margin-top:20px;width:100%;min-height:100%;display:flex!important;justify-content:center;align-items:center;">
                         <v-btn color="error" @click="fechar()">
                            FECHAR
                        </v-btn>
                    </div>
                </v-card>



            </v-card-text>


        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from 'dayjs'

// import BotaoTutorial from '../BotaoTutorial.vue';

  export default {
    name: "ModalAssinaturaRelatorios",
    props: ["exibirModalAssinatura", "pedido","dados"],
    data: () => ({
        categoria: {
            id: null,
            nome: null,
            tempopreparo: 40,
            horainicio: "00:00:00",
            horafinal: "23:59:00",
            ativo: true,
            flbebida: false,
        },
        imgsrc: null
    }),
    components: {
        // BotaoTutorial
    },
    mounted() {

      console.log(this.pedido)


        try {

            this.$http("pdv/getassinaturacomanda/" + this.pedido.numpedido).then(resp => {

              console.log(resp.data[0].imgassinatura)

                this.imgsrc = resp.data[0].imgassinatura;
            }).catch(error => {
                console.log(error);
            });

        } catch (error) {
            console.log(error)
        }
    },
    watch: {
        pedido() {
            this.$http("pdv/getassinaturacomanda/" + this.pedido.numpedido).then(resp => {
                this.imgsrc = resp.data[0].imgassinatura;
            }).catch(error => {
                console.log(error);
            });
        }
    },
    methods: {
        direcionar() {
            this.$router.push(this.url);
        },
        fechar() {
            this.$emit("fechar");
        },
        validarDados(obj) {
            if (!obj.idpdv) {
                this.$alertar("warning", "PDV não Selecionado", "=(");
                return false;
            }
            if (!obj.nome) {
                this.$alertar("warning", "Nome não Informado!", "=(");
                return false;
            }
            if (!obj.tempopreparo) {
                this.$alertar("warning", "Tempo de Preparo não Informado!", "=(");
                return false;
            }
            if (!obj.horainicio) {
                this.$alertar("warning", "Horário Inicial não Informado!", "=(");
                return false;
            }
            if (!obj.horafinal) {
                this.$alertar("warning", "Horário Final não Informado!", "=(");
                return false;
            }
            return true;
        },
        criarCategoria() {
            let obj = {
                idpdv: this.idpdvcd,
                nome: this.categoria.nomecategoriaprodcd,
                tempopreparo: this.categoria.tempopreparo,
                horainicio: dayjs(this.categoria.horainicio).format("HH:mm:ss"),
                horafinal: dayjs(this.categoria.horafinal).format("HH:mm:ss"),
                flbebida: this.categoria.flbebida
            };
            if (this.validarDados(obj)) {
                this.$http.post(`pdv/categorias`, obj).then(() => {
                    this.$alertar("success", "Categoria Criada Com sucesso!", "=)");
                    this.$emit("atualizarLista");
                }).catch((error) => {
                    this.$alertar("warning", "Não foi possivel atualizar a categoria", "=(");
                    console.log(error);
                });
            }
        }
    },
}
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.botaoModalLocal{
    width:100%;
    height: 50px;
    display: block;
    margin-bottom:30px;
    border:0px;
    font-weight: bold;
    color:white;
}

.botaoModalLocalAmarelo{background-color: rgb(239,175,62);}
.botaoModalLocalVerde{background-color: rgb(0,165,51);}
.botaoModalLocalAzul{background-color: rgb(63,81,181);}
.botaoModalLocalVermelho{background-color: rgb(216, 37, 37);}
.headerTitulo{font-weight: bold;}
.numeroForm{height: 50px!important;}


  .inputsHorario{
    background-color:white;
    text-align:center;
    border-radius:15px;
    min-height:8vh;
    font-size:25px;
    padding:10px;
    border: 1px solid #819ab4;
    margin-right:10px;
    width: 100px;
  }
</style>

